"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTipo = exports.selectHorarios = exports.selectDormitorios = exports.selectCapacidad = exports.selectBano = exports.default = void 0;
var _default = [];
exports.default = _default;
const selectBano = [{
  label: 'Sin baño',
  value: 0
}, {
  label: '1 Baño',
  value: 1
}, {
  label: '2 Baños',
  value: 2
}, {
  label: '3 Baños',
  value: 3
}, {
  label: '4 Baños',
  value: 4
}, {
  label: '5 Baños',
  value: 5
}, {
  label: '6 Baños o más',
  value: 6
}];
exports.selectBano = selectBano;
const selectCapacidad = [{
  label: '1 Persona',
  value: 1
}, {
  label: '2 Personas',
  value: 2
}, {
  label: '3 Personas',
  value: 3
}, {
  label: '4 Personas',
  value: 4
}, {
  label: '5 Personas',
  value: 5
}, {
  label: '6 Personas',
  value: 6
}, {
  label: '7 Personas',
  value: 7
}, {
  label: '8 Personas',
  value: 8
}, {
  label: '9 Personas',
  value: 9
}, {
  label: '10 Personas',
  value: 10
}, {
  label: '11 Personas',
  value: 11
}, {
  label: '12 Personas',
  value: 12
}, {
  label: '13 Personas',
  value: 13
}, {
  label: '14 Personas',
  value: 14
}, {
  label: '15 Personas',
  value: 15
}, {
  label: '16 Personas',
  value: 16
}, {
  label: '17 Personas',
  value: 17
}, {
  label: '18 Personas',
  value: 18
}, {
  label: '19 Personas',
  value: 19
}, {
  label: '20 Personas',
  value: 20
}];
exports.selectCapacidad = selectCapacidad;
const selectDormitorios = [{
  label: 'Monoambiente',
  value: 0
}, {
  label: '1 Dormitorio',
  value: 1
}, {
  label: '2 Dormitorios',
  value: 2
}, {
  label: '3 Dormitorios',
  value: 3
}, {
  label: '4 Dormitorios',
  value: 4
}, {
  label: '5 Dormitorios',
  value: 5
}, {
  label: '6 Dormitorios',
  value: 6
}, {
  label: '7 Dormitorios',
  value: 7
}, {
  label: '8 Dormitorios',
  value: 8
}, {
  label: '9 Dormitorios',
  value: 9
}, {
  label: '10 Dormitorios',
  value: 10
}, {
  label: '11 Dormitorios',
  value: 11
}, {
  label: '12 Dormitorios',
  value: 12
}, {
  label: '13 Dormitorios',
  value: 13
}, {
  label: '14 Dormitorios',
  value: 14
}, {
  label: '15 Dormitorios o más',
  value: 15
}];
exports.selectDormitorios = selectDormitorios;
const selectHorarios = [{
  label: '00'
}, {
  label: '01'
}, {
  label: '02'
}, {
  label: '03'
}, {
  label: '04'
}, {
  label: '05'
}, {
  label: '06'
}, {
  label: '07'
}, {
  label: '08'
}, {
  label: '09'
}, {
  label: '10'
}, {
  label: '11'
}, {
  label: '12'
}, {
  label: '13'
}, {
  label: '14'
}, {
  label: '15'
}, {
  label: '16'
}, {
  label: '17'
}, {
  label: '18'
}, {
  label: '19'
}, {
  label: '20'
}, {
  label: '21'
}, {
  label: '22'
}, {
  label: '23'
}];
exports.selectHorarios = selectHorarios;
const selectTipo = [{
  label: 'Bungalow',
  value: 1
}, {
  label: 'Casa',
  value: 2
}, {
  label: 'Complejo',
  value: 3
}, {
  label: 'Dúplex',
  value: 4
}, {
  label: 'Cabaña',
  value: 5
}, {
  label: 'Chalet',
  value: 6
}, {
  label: 'Apart',
  value: 7
}, {
  label: 'Departamento',
  value: 8
}, {
  label: 'Resort',
  value: 9
}, {
  label: 'Suite',
  value: 10
}, {
  label: 'Hotel',
  value: 11
}, {
  label: 'Hostel',
  value: 12
}, {
  label: 'Hostería',
  value: 13
}, {
  label: 'Posada',
  value: 14
}, {
  label: 'Bed & Breakfast',
  value: 15
}, {
  label: 'Quintas',
  value: 16
}, {
  label: 'Estancias',
  value: 17
}, {
  label: 'Habitacion',
  value: 18
}, {
  label: 'Motorhome',
  value: 19
}];
exports.selectTipo = selectTipo;